import { FLOAT_PAGE_NUMBER } from '../constants/common.constants'
import './FloatPageNumber.scss'

export default function AddModuleFn() {
  let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
  let fragments = [
    {
      target: 'pdf-viewer-container-with-ruler',
      action: ACTIONS.APPEND,//'append',
      template:
        `<layer name="${FLOAT_PAGE_NUMBER}" @controller="auto-scroll:AutoScrollFloatPageNumberController" class="${FLOAT_PAGE_NUMBER} centerv right" visible="false" focus="false" append-to=".fv__ui-portfolio-previewer-container">
          <span></span>
        </layer>`,
    },
  ];

  return { fragments };
}

export { AddModuleFn };